import { render, staticRenderFns } from "./model-mixin.vue?vue&type=template&id=3f6d2a5e&"
import script from "./model-mixin.vue?vue&type=script&lang=js&"
export * from "./model-mixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports